export const formatDeltaMs = (deltaMs = 0) => {
    const safeDelta = Number.isFinite(deltaMs) ? deltaMs : 0;
    const seconds = Math.floor(safeDelta / 1000);
    const millis = Math.floor(safeDelta % 1000);
    return `${String(seconds).padStart(2, '0')}:${String(millis).padStart(3, '0')}`;
};

export default formatDeltaMs;
